export const shouldNavigateToFoldersAfterAISearchClose = (
  hasAISearchImport: boolean,
  saved: boolean,
): boolean => hasAISearchImport && saved;
